import { ClientInterface } from 'interfaces';

import { kamOptions } from './138.kam'
import { wapoOptions } from './159.wapo'
import { whiteSalmonOptions } from './209.white-salmon'
import { broadviewOptions } from './214-broadview';
import { ryanHamiltonOptions } from './218-ryan-hamilton';
import { molineOptions } from './219-moline';

export interface CustomOptionProps {
  headerIsShown: boolean;
  hiddenLinks: string[];
  links: any;
  customFooterClass?: any;
  customFooterLinks?: any;
  buttons: any;
  customText: any;
  questionsList: any;
  videoThumbnails: any;
  helpfulHintsEnabled: boolean;
}

// Custom client styling
export function setClients(client: ClientInterface) {
  // Kam
  if (client?.id === '138') {
    document.body.setAttribute('class', 'active Kam');
    document.body.setAttribute('style', `background-image: url(${client.backgroundImageURL || client.logoURL});`);
  }

  // Wapo
  else if (client?.id === '159') {
    document.body.setAttribute('class', 'active Wapo');
  }

  // White Salmon (city)
  else if (client?.id === '209') {
    document.body.setAttribute('class', 'active WhiteSalmon');
  }

  // BroadView (city)
  else if (client?.id === '214') {
    document.body.setAttribute('class', 'active broadView');
  }

  // Ryan Hamilton (city)
  else if (client?.id === '218') {
    document.body.setAttribute('class', 'active ryanHamilton');
  }

  // Moline (city)
  else if (client?.id === '219') {
    document.body.setAttribute('class', 'active moline');
  }

  // Fountain Hills Adjustment (Client Id #241)
  // + any others
  else {
    document.body.setAttribute('class', 'active ' + window.location.pathname.split('/')[1]);
  }
}

export function getClientOptions(client: ClientInterface) {
  return customClientOptions[client?.id]
}

export function clientHasCustomOptions(clientId?: string): Boolean {
  return clientId === '138' || clientId === '159' || clientId === '209'
}

export const customClientOptions: any = {
  '138': kamOptions,
  '159': wapoOptions,
  '209': whiteSalmonOptions,
  '214': broadviewOptions,
  '218': ryanHamiltonOptions,
  '219': molineOptions,
}
